/* ==========================================================================
   Naru — cart drawer additions

   Only job: remember that the upsell was dismissed, for this tab, so it does
   not reappear every time the drawer opens. sessionStorage rather than
   localStorage — declining today should not silence the offer forever.

   Wrapped in try/catch because storage throws outright in some privacy
   modes, and a dismissed nudge is not worth breaking a cart over.
   ========================================================================== */

(function () {
  'use strict';

  var KEY = 'naru:cart-upsell-dismissed';

  function dismissed() {
    try {
      return sessionStorage.getItem(KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function remember() {
    try {
      sessionStorage.setItem(KEY, '1');
    } catch (e) {
      /* private mode — the nudge simply reappears next open */
    }
  }

  function apply(scope) {
    var root = scope || document;
    var nodes = root.querySelectorAll('[data-naru-cart-upsell]');

    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];

      if (dismissed()) {
        node.hidden = true;
        continue;
      }

      if (node.__naruBound) continue;
      node.__naruBound = true;

      var button = node.querySelector('[data-naru-cart-upsell-dismiss]');
      if (!button) continue;

      (function (el) {
        el.querySelector('[data-naru-cart-upsell-dismiss]').addEventListener(
          'click',
          function () {
            remember();
            el.hidden = true;
          }
        );
      })(node);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      apply(document);
    });
  } else {
    apply(document);
  }

  // The drawer re-renders its contents after every cart change, which
  // recreates the node and loses the hidden state.
  document.addEventListener('shopify:section:load', function (e) {
    apply(e.target);
  });
  document.addEventListener('cart:refresh', function () {
    apply(document);
  });
})();
